export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13025.2c53b34a.jpg";